<template>
  <div class="mall-order-complete">
    <div class="page">
      <MallResultMessage
        :icon="resultIcon"
        :title="'결제가 완료되었어요'"
        :messageLines="['주문 내역에서', '결제 정보를 확인할 수 있어요.']"
      />
      <MallBottomBar :buttons="buttons" @click="confirm" />
    </div>
  </div>
</template>

<script>
import MallBottomBar from '@/components/new/molecules/MallBottomBar.vue'
import MallResultMessage from '@/components/new/organisms/MallResultMessage.vue'

export default {
  name: 'MallOrderComplete',
  components: {
    MallBottomBar,
    MallResultMessage,
  },
  data() {
    return {
      profileId: Number(this.$route.query.profileId) || null,
      // 한 번만 재생되는 애니메이션 이미지 (재생이 끝난 이미지는 다시 재생되지 않아 진입할 때마다 주소를 다르게 함)
      resultIcon: require('@/assets/mall/img_result_check.webp') + '?t=' + Date.now(),
      buttons: [
        { key: 'confirm', label: '확인', type: 'primary' },
      ],
    }
  },
  mounted() {
    ChannelIO('shutdown')
  },
  methods: {
    confirm() {
      // TODO: 주문내역 화면이 생기면 연결 여부 확인 - 지금은 쇼핑 홈으로 이동
      this.$router.replace({ path: '/mall/shop', query: { profileId: this.profileId } })
    },
  },
}
</script>

<style scoped>
  .mall-order-complete {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  /* 하단 고정 버튼 영역 위에서 가운데 정렬 - Figma(360x780) 기준 위치(상태바 제외 207px)에 맞춤 */
  .page {
    display: flex;
    width: 100%;
    min-height: 100vh;
    padding: 0 32px 117px 32px;
    flex-direction: column;
    justify-content: center;
    background: #FFF;
    box-sizing: border-box;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/MallOrderComplete.vue